import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { adaptJob } from '../lib/adapters';

export function useJobs() {
  return useQuery({
    queryKey: ['jobs'],
    queryFn: async () => {
      const [jobs, assignments] = await Promise.all([
        api.jobs.list(),
        api.assignments.list(),
      ]);
      return jobs.map((j) => adaptJob(j, assignments));
    },
    staleTime: 60 * 1000, // 1 min
  });
}
